import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
} from 'admin-on-rest'
import Filters from './Filters'

export const DealershipPerformance = (props) => (
    <List {...props}
		title="Dealership Performance Overview Report"
		filters={<Filters />}
		actions={<ListActions refreshInterval="900000" />}
		perPage={100}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid>
					<TextField source="dealership" label="Dealership" />
					<NumberField source="releases" label="Releases" />
					<NumberField source="performance" label="Performance Score" options={{ maximumFractionDigits: 2, style: 'percent' }} />
					<NumberField source="doc_def_rate" label="Doc Def Rate" options={{ maximumFractionDigits: 2, style: 'percent' }} />
					<NumberField source="avg_transmittal" label="Avg Transmittal Days" options={{ maximumFractionDigits: 2 }} />
					<NumberField source="avg_collection_wo_doc_def" label="Avg Collection of Proceeds w/o Doc Def" options={{ maximumFractionDigits: 2 }} />
					<NumberField source="avg_collection_w_doc_def" label="Avg Collection of Proceeds w/ Doc Def" options={{ maximumFractionDigits: 2 }} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/DealershipPerformance.js